var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('TheFooterNavbar'),_c('ContainerInner',{staticClass:"footer__inner"},[_c('div',{staticClass:"footer__disclaimer",domProps:{"innerHTML":_vm._s(_vm.gdpr.wysiwyg)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }